module.exports = "/_next/static/images/75cc3d803d9d31ecb9a7fa1aba49d57c-nucommunity-md@1x.jpg";